export enum AssignmentLevelType {
    Contract = 1,
    Candidate = 2,
    Recruiter = 3,
    Agency = 4,
    Facility = 5,
    QMAssociation = 6
}
